"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The floating label a chart puts at the thing the cursor is over.
 *
 * Shared by every chart that has one, because they are the same object with the
 * same rules: never under the cursor, always kept mounted so it can fade out as
 * well as in, and always growing upward from the mark it describes.
 *
 * The two "over bar" variants exist because a histogram bar's top edge is a
 * wide flat line: a popover sitting the scatter's distance above it reads as
 * touching, where the same gap above a six-pixel dot reads as clear.
 */
const styles = exports.styles = {
  popover: {
    position: "x10l6tqk",
    pointerEvents: "x47corl",
    zIndex: "xhtitgo",
    whiteSpace: "xuxw1ft",
    fontFamily: "x1wl88yq",
    fontSize: "x9bimuu",
    color: "x10kmngs",
    backgroundColor: "xk6p4me",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingTop: "x1iul6r4",
    paddingBottom: "xes99ow",
    paddingLeft: "x15u6esi",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1arb9wb",
    boxShadow: "xdi6r1s",
    transitionProperty: "x6o7n8i",
    transitionDuration: "xgdialr",
    transitionTimingFunction: "x9lcvmn",
    $$css: true
  },
  popoverHidden: {
    opacity: "xg01cxk",
    transform: "x8ody75",
    $$css: true
  },
  popoverShown: {
    opacity: "x1hc1fzr",
    transform: "x8s80hf",
    $$css: true
  },
  popoverHiddenOverBar: {
    opacity: "xg01cxk",
    transform: "xzfx33m",
    $$css: true
  },
  popoverShownOverBar: {
    opacity: "x1hc1fzr",
    transform: "x1ofsqa5",
    $$css: true
  },
  popoverRow: {
    display: "x1lliihq",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  popoverFigure: {
    fontFamily: "xm3uy08",
    $$css: true
  },
  popoverWord: {
    fontFamily: "x1wl88yq",
    paddingLeft: "xf00w7v",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: true
  },
  popoverSeparator: {
    fontFamily: "x1wl88yq",
    color: "xcdm7ny",
    paddingLeft: "xf00w7v",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1d60ukw",
    $$css: true
  }
};